module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n      编号：\n      "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  }), _vm._v("  \n      序列号：\n      "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入序列号"
    },
    model: {
      value: (_vm.deviceSn),
      callback: function($$v) {
        _vm.deviceSn = $$v
      },
      expression: "deviceSn"
    }
  }), _vm._v("  连接类型：\n      "), _c('DropdownSelect', {
    attrs: {
      "action": _vm.api.admin.device.listtype,
      "textField": "name",
      "valueField": "id"
    },
    model: {
      value: (_vm.typeId),
      callback: function($$v) {
        _vm.typeId = $$v
      },
      expression: "typeId"
    }
  }), _vm._v("  经销商：\n      "), _c('DropdownSelect', {
    attrs: {
      "action": _vm.api.admin.dealer.all,
      "textField": "name",
      "valueField": "id"
    },
    model: {
      value: (_vm.dealerId),
      callback: function($$v) {
        _vm.dealerId = $$v
      },
      expression: "dealerId"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('page-table', {
    attrs: {
      "data-api": this.api.admin.device,
      "viewable": false,
      "keyField": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceSn",
      "label": "序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "设备类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "设备名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dealerName",
      "label": "经销商"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireData",
      "label": "过期时间",
      "formatter": _vm.dateFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "绑定"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dealerId == null) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleBind(scope.$index, scope.row)
            }
          }
        }, [_vm._v("绑定经销商")]) : _vm._e(), _vm._v(" "), (scope.row.dealerId != null) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleUnbind(scope.$index, scope.row)
            }
          }
        }, [_vm._v("取消绑定")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "控制"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleStart(scope.$index, scope.row)
            }
          }
        }, [_vm._v("启动")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleStop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("停止")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleUnlock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("解锁")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleLock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("锁定")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.statusFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unlocked",
      "label": "锁定状态",
      "formatter": _vm.unlockedFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "添加时间",
      "formatter": _vm.dateFormatter
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "绑定经销商",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.bindForm,
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备id"
    }
  }, [_vm._v(_vm._s(_vm.bindForm.deviceId))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "序列号"
    }
  }, [_vm._v(_vm._s(_vm.bindForm.deviceSn))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('DropdownSelect', {
    attrs: {
      "action": _vm.api.admin.dealer.all,
      "textField": "name",
      "valueField": "id"
    },
    model: {
      value: (_vm.bindForm.dealerId),
      callback: function($$v) {
        _vm.$set(_vm.bindForm, "dealerId", $$v)
      },
      expression: "bindForm.dealerId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效天数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.bindForm.days),
      callback: function($$v) {
        _vm.$set(_vm.bindForm, "days", $$v)
      },
      expression: "bindForm.days"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindDealer
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48bad9d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/device/List.vue
// module id = 1142
// module chunks = 2